module.exports = __webpack_public_path__ + "img/pantalla-2-5.0d7e53c0.png";